import setEmojiSelectedIndex from '../actions/setEmojiSelectedIndex';
import { EMOJI_SUGGESTION_LABEL_PREFIX } from '../constants';
import { EmojiPickerViewState } from '../store/schema/EmojiPickerViewState';
import { observer } from 'mobx-react-lite';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import EmojiIcon from 'owa-expressions-view/lib/components/Emoji/EmojiIcon';
import { PluginUIProps } from 'owa-editor/lib/store/schema/PluginWithUI';
import EmojiPickerPlugin from '../plugin/EmojiPickerPlugin';
import * as React from 'react';

const styles = require('./EmojiPickerResult.scss');
const classNames = require('classnames/bind').bind(styles);

interface EmojiPickerResultOptionProps
    extends PluginUIProps<EmojiPickerViewState, EmojiPickerPlugin> {
    currentIndex: number;
    emoji?: string;
}

export default observer(function EmojiPickerResultOption(props: EmojiPickerResultOptionProps) {
    const { viewState, plugin, currentIndex, emoji } = props;
    const selectedIndex = viewState.selectedEmojiIndex;

    const onClickEmojiPickerOption = React.useCallback(() => {
        plugin.dataProvider.selectOption();
    }, []);
    const onMouseOverEmojiPickerOption = React.useCallback(() => {
        setEmojiSelectedIndex(viewState, currentIndex);
    }, [viewState, currentIndex]);

    return emoji ? (
        <span
            id={EMOJI_SUGGESTION_LABEL_PREFIX + currentIndex.toString()}
            role="listitem"
            key={currentIndex}
            onMouseOver={onMouseOverEmojiPickerOption}>
            <EmojiIcon
                key={emoji}
                name={emoji}
                isSelected={selectedIndex === currentIndex}
                cssClassName={classNames(styles.emojiIcon)}
                onClick={onClickEmojiPickerOption}
            />
        </span>
    ) : (
        <IconButton
            className={classNames(styles.more, styles.emojiIcon, {
                isSelected: selectedIndex === currentIndex,
            })}
            onMouseOver={onMouseOverEmojiPickerOption}
            onClick={onClickEmojiPickerOption}
            iconProps={{ iconName: 'More' }}
        />
    );
});
